<template>
  <div class="news-container">
    <div class="section">
      <div class="body-container">
        <!-- 通知公告 -->
        <div class="notice-box">
          <div class="main-title">
            <div class="link-list">
              <span class="text">{{ menu.menu_name }}</span>
            </div>
            <a
              :href="`/notice.html?name=${menu.menu_name}&menuId=${menu.id}`"
              class="more-btn"
              target="_blank"
              style="margin-top: 6px"
            >
              <span class="btn-text">查看全部</span>
              <i class="iconfont icongengduo"></i>
            </a>
          </div>
          <div class="content">
            <a
              class="main-notice"
              target="_self"
              :href="
                `/noticeDetail.html?type=1&id=${mainRecommendNews.id}&name=${menu.menu_name}&menuId=${menu.id}`
              "
              v-if="mainRecommendNews"
            >
              <img :src="mainRecommendNews ? mainRecommendNews.news_cover_url : '' " />
              <div class="main-notice-content">
                <div class="main-notice-top" :title="mainRecommendNews.news_name">
                  <div class="title text-overflow">
                    {{ mainRecommendNews.news_name }}
                  </div>
                </div>
              </div>
            </a>
            <div class="notice-list" v-if="newsList.length">
              <el-link
                :underline="false"
                class="notice-item"
                :href="`/noticeDetail.html?type=1&id=${item.id}&name=${menu.menu_name}&menuId=${menu.id}`"
                v-for="(item, index) in newsList"
                :key="index"
              >
                <span class="title text-overflow" :title="item.news_name">· {{ item.news_name }}</span>
                <div class="date">
                  {{ $utils.formatDate(item.publish_time, "YYYY-MM-DD") }}
                </div>
              </el-link>
            </div>
            <div v-else class="no-data">
              <Empty type="message" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Empty } from 'zhs-components'
export default {
  props: {
    menu: Object
  },
  components: {
    Empty
  },
  created() {
    this.getNewsList();
  },
  data() {
    return { 
      newsList: [], 
      mainRecommendNews: null,
    }
  },
  methods: {
    async getNewsList() {
      const res = (await this.$http.getHomeNews({ num: this.menu.num, menu_id: this.menu.id })) || [];
      // console.log('新闻-首页', res);
      if (res.length && res[0].news_cover_url) {
        this.mainRecommendNews = res.shift();
      }
      this.newsList = res;
      console.log(this.newsList);
    }
  },
};
</script>
<style lang="scss" scoped>
.news-container {
  min-height: 300px;
  // background-color: rgba(245, 245, 245, .5);
  .section {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
  }
}
.btn-text {
  margin-right: 8px;
}
.main-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
  // overflow: hidden;
  .link-list {
    // flex: 1;
    // margin-top: 6px;
    height: 28px;
    font-size: 20px;
    line-height: 28px;
    .text {
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      letter-spacing: 1px;
    }
  }
  .more-btn {
    flex: 0 0 74px;
    cursor: pointer;
    margin-right: 0;
  }
}
.notice-box .content {
  margin-top: 20px;
  display: flex;
  .main-notice {
    width: 468px;
    height: 264px;
    background-color: #fff;
    cursor: pointer;
    position: relative;
    margin-right: 20px;
    img {
      display: block;
      width: 468px;
      height: 264px;
      object-fit: cover;
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-filter: brightness(70%);
      /* Chrome, Safari, Opera */
      filter: brightness(70%);
    }
    .main-notice-content {
      padding: 15px;
      line-height: 22px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: url(~assets/images/home/news_item_bg.png);
    }
    .main-notice-top {
      .title {
        font-size: 16px;
        color: #fff;
        line-height: 22px;
      }
      .date {
        font-size: 12px;
        line-height: 17px;
        color: #fff;
      }
    }
    .main-notice-text {
      margin-top: 25px;
      font-size: 12px;
      line-height: 17px;
      color: #999;
    }
  }
  .notice-list {
    flex: 1;
  }
  .notice-item {
    height: 60px;
    display: block;
    .title {
      font-size: 16px;
      line-height: 20px;
      max-width: 489px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .date {
      font-size: 12px;
      line-height: 17px;
      color: #999999;
    }
  }
}
</style>
<style scoped>
:deep(.el-link--inner) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px dashed #ddd;

}
</style>